import { Typography } from "@mui/material";
import PropTypes from "prop-types";

const styles = {
  div1: {
    position: "absolute",
    right: "2px",
    opacity: "0.7",
  },
};

export function KeikkaIdContainer(props) {
  const keikkaId = props.keikkaId;
  const varmenne = props.varmenne;
  return (
    <div style={styles.div1}>
      <Typography color="primary" fontSize="small" fontFamily="courier">
        {keikkaId}/{varmenne}
      </Typography>
    </div>
  );
}

KeikkaIdContainer.propTypes = {
  keikkaId: PropTypes.number,
  varmenne: PropTypes.string,
};
